export default "__VITE_ASSET__c85e1eb8__"